<template>
    <el-dialog
        :visible="isVisible"
        @close="hide"
        :title="title"
        :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <outgoing-number-form
            v-if="isInitialized"
            v-bind="formData"
            @stored="onStored"
        ></outgoing-number-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';
  import OutgoingNumberForm from '../../components/outgoing-number/form';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      OutgoingNumberForm,
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Outgoing Number'
        }

        return 'Create Outgoing Number'
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       * @param {object} data
       */
      onStored({message, data}) {
        _.isString(message) && this.$message.success(message);
        if (data) {
          this.formData = data;
        } else {
          this.hide();
        }

        eventBus.$emit('refresh-outgoing-number-table');
      },
    },

    created() {
      eventBus.$on('show-add-outgoing-number-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-add-outgoing-number-dialog', this.show);
    }
  }
</script>
